<template>
    <validation-provider tag="div" :name="label" :rules="rules" v-slot="{ errors }" :vid="vid">
        <v-text-field
            :clearable="clearable"
            :error-messages="errors"
            :field="field"
            :label="label"
            :placeholder="placeholder"
            :type="type === 'password' ? (show ? 'text' : 'password') : type"
            outlined
            :hide-details="hideDetails"
            v-bind="$attrs"
            v-model="innerValue"
            v-on="$listeners"
        >
            <template #append v-if="type === 'password'">
                <v-icon @click="show = !show">{{ type === 'password' ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
            </template>
        </v-text-field>
    </validation-provider>
</template>

<script>
export default {
    props: {
        clearable: { type: Boolean },
        field: { type: String, default: 'outlined' },
        placeholder: { type: String, default: '' },
        label: { type: String, default: '' },
        rules: { type: [Object, String], default: '' },
        type: { type: String, default: 'text' },
        hideDetails: { type: Boolean, default: false },
        value: { type: null },
        vid: { type: String, default: '' }
    },
    data: () => ({
        innerValue: '',
        show: false
    }),
    watch: {
        innerValue(newVal) {
            this.$emit('input', newVal)
        },
        value(newVal) {
            this.innerValue = newVal
        }
    },
    created() {
        if (this.value) this.innerValue = this.value
    }
}
</script>
